"use client";

import React, { useEffect, useState } from "react";
import moment from "moment";
import { Timer } from "lucide-react";

type RegistrationCloseTimerProps = {
  closeDate?: string;
};

const RegistrationCloseTimer = ({ closeDate }: RegistrationCloseTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string | null>(null);

  useEffect(() => {
    if (!closeDate) {
      setTimeLeft(null);
      return;
    }

    const closeMoment = moment(closeDate);

    const update = () => {
      const now = moment();
      const diffMs = closeMoment.diff(now);

      if (diffMs <= 0) {
        setTimeLeft(null);
        return;
      }

      const duration = moment.duration(diffMs);
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      const parts: string[] = [];
      if (days > 0) parts.push(`${days}d`);
      parts.push(
        `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
      );

      setTimeLeft(parts.join(" "));
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [closeDate]);

  if (!timeLeft) {
    return null;
  }

  return (
    <div
      className="absolute -top-3.5 right-2 bg-red-50 text-red-700 border border-red-400 rounded-full px-3 py-1 text-xs font-medium flex items-center shadow-sm z-10"
      aria-label="Registration closes soon"
    >
      <Timer size={16} className="mr-1" />
      <span>Registration closes in {timeLeft}</span>
    </div>
  );
};

export default RegistrationCloseTimer;
